import React,{useEffect,useState} from 'react';
import ListItem from '../components/ListItem';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import {allStates,replaceAll,replaceAllByArray} from '../components/Helper';
import { BrowserRouter as Router,Routes, Route, Link,useParams } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import '../App.css';


const CommunityActionCenterDetail=()=>{

let { item } = useParams();
const [cookies, setCookie,removeCookie] = useCookies(['user_FirstName','user_LastName','user_Email','user_Phone','user_Zip']);
const [data, setData] = useState([{"name":"","phone":"","email":"","domain":""}]);
const [foundState, setFoundState] = useState([]);


const dataFetch = async () => {

  if(typeof item === 'undefined'){
    item='';
  }
  await fetch('https://api.hudhousingnetwork.com/community-action-center-detail?item='+item)
        .then(response => response.json())
        .then((data) =>{ 
            setData(data);
          //console.log(data)
          }
        );

};


useEffect(()=>{
 console.log('Loaded!');  
dataFetch(); 

},[])



const setClick=(val)=>{
  var url='/public-housing-waiting-lists/';
  url=url+val;
  window.location.href=url;
  //console.log("clicked "+val.toLowerCase())
}

/*allStates.map((postData) => {
  if(postData['state_code']=='AL'){
    console.log(postData['state'])
  }
})*/

let name=replaceAllByArray(data[0].name,[" inc",",","&#038;","&#8211;","&#8217;"],"");

  return (

<>
  <Header />
  <div className="content_wrapper">
    
    <div className="main-content main-community community-detail">
      <h2 className="top-heading">{name}</h2>
      
      {/*}<select className="statesDD" onChange={(e)=>setClick(e.target.value)} >
      {
          allStates.map((postData,index) => {            
            var selected = postData['state_code'].toLowerCase()==state ? 'selected' : '';
            return (<option key={index} selected={selected} value={postData['state_code'].toLowerCase()}>{postData['state']}</option>)
          
        })
      }        
      </select><br />
      {*/}
      
      
      <div className="detail-icons">

      {cookies.user_Email ? 
        (
        <>
        <p><img src="/img/c-telephone-icon.png" /> <a href={'tel:'+data[0].phone}>{data[0].phone}</a></p>
        <p><img src="/img/c-email-icon.png" /> <a href={'mailto:'+data[0].email}>{data[0].email}</a></p>
        <p><img src="/img/c-web-icon.png" /> <a href={data[0].domain}>Visit Website</a></p>
        <p><img src="/img/c-location-icon.png" />8015551212</p>
        </>
        )
        :
        (
        <>
        <p><img src="/img/c-telephone-icon.png" /> Register To View</p>
        <p><img src="/img/c-email-icon.png" />Register To View</p>
        <p><img src="/img/c-web-icon.png" />Register To View</p>
        <p><img src="/img/c-location-icon.png" />Register To View</p>
        </>
        )
      
      }        
      </div>
      <button className="c-view-more-btn">View More Community Action Centers</button>
      
      <div className="c-content2" style={{padding:'0px !important;'}}>
        <h4 className="c-detail-h4">Services Provided By {name}</h4>
                <p><strong>Children and Youth Services:</strong> Head Start, Literacy Programs, Dropout Prevention, After School Enrichment and Tutoring, Teen Centers, Recreation and Sports Programs, Special Supplemental Nutrition Program for Women, Infants & Children (WIC), Well-Baby Clinics, Summer Enrichment Programs, Summer Food Programs, Child Care Food Programs, Pregnancy Prevention, Character Education, Substance Abuse Education, Prevention & Counseling, Summer Youth Employment Programs, College Counseling and Placement.</p>

        <p><strong>Support The Working Poor:</strong> Child Care, Adult Education, GED Preparation, Job Training and On-The-Job Support, Job Search Assistance, Job Placement, Job Creation, Small Business Development, Loan Funds, Senior Community Service Employment, Displaced Homemaker Programs, Budget Counseling, Internet Training and Access.</p>

        <p><strong>Crisis Support:</strong> Homeless Shelters & Drop-In Centers, Utility Deposits, Eviction Prevention, Domestic Violence Programs & Shelters, Transitional Housing, Food Pantries Energy Crisis Assistance & Shelter, Emergency Food Baskets, Emergency Clothing, Supplies, and Services – including Medical & Legal Volunteer Help.</p>

        <p><strong>Elderly and Senior Support:</strong> Meals on Wheels, In-Home Care Programs, Senior Centers, Senior Day Care, Foster Grandparents, Congregate Meals, Medical Transportation, Volunteer Chore Services.</p>

        <p><strong>Family Housing and Food Assistance:</strong> Comprehensive Family Development Support, Nutrition Education, Parenting Education, Community Gardens and Canneries, Food Stamps, Health Clinics, Weatherization Assistance, Energy Assistance, Rental Assistance, Home Ownership Programs, Community Centers, Individual Development Accounts.</p>

      </div>
      <div className="c-map"><img src="/img/c-map.png"  /></div>

      <div className="list-box">
        <img src="/img/heart.png" className="heart" />
        <h3>Utah County Housing Authority</h3>
        <p>500 W 900 N Provo Utah 84604</p>
        <div className="list-box-flex">
          <div><button className="open-btn">open</button></div>
          <div className="list-box-icon">
            <a href="" target="_blank"><img src="/img/Group238489.png" /></a>
            <a href="#"><img src="/img/Group238491.png" /></a>
            <a href="#"><img src="/img/Group238493.png" /></a>
            <a href="#"><img src="/img/Group238494.png" /></a>
          </div>
        </div>
      </div>

      <div className="list-box">
        <img src="/img/heart.png" className="heart" />
        <h3>Utah County Housing Authority</h3>
        <p>500 W 900 N Provo Utah 84604</p>
        <div className="list-box-flex">
          <div><button className="close-btn">Close</button></div>
          <div className="list-box-icon">
            <a href="" target="_blank"><img src="/img/Group238489.png" /></a>
            <a href="#"><img src="/img/Group238491.png" /></a>
            <a href="#"><img src="/img/Group238493.png" /></a>
            <a href="#"><img src="/img/Group238494.png" /></a>
          </div>
        </div>
      </div>

      <div className="apply-for"><img src="/img/curve-arrow.png" />Apply For Assistance Now</div>

    </div>

  <Sidebar />
  </div>
  <div className="content_wrapper">
    <div className="side-box">
      <img src="/img/apt1.png" />
      <div className="side-box-content">
        <h3>Spring View Apartments</h3>
        <p>Read our getting started guide</p>
        <div className="side-box-flex">
          <h4>Section 8 Apartment</h4>
          <a className="applyLink" href="/">Apply</a>  
        </div>  
      </div>
    </div>
    <div className="side-box">
      <img src="/img/apt2.png" alt="" />
      <div className="side-box-content">
        <h3>Spring View Apartments</h3>
        <p>Read our getting started guide</p>
        <div className="side-box-flex">
          <h4>Section 8 Apartment</h4>
          <a className="applyLink" href="/">Apply</a>  
        </div>  
      </div>
    </div>
    <div className="side-box">
      <img src="/img/apt2.png" />
      <div className="side-box-content">
        <h3>Spring View Apartments</h3>
        <p>Read our getting started guide</p>
        <div className="side-box-flex">
          <h4>Section 8 Apartment</h4>
          <a className="applyLink" href="/">Apply</a>  
        </div>  
      </div>
    </div>
  </div>
  <div className="content_wrapper">
    <div className="bottom-box">
      <div className="bottom-box-flex">
        <div className="bottom-box-image"><img src="/img/Housing-authority.png" /></div>
        <div className="bottom-box-content">
          <h2>Housing-authority</h2>
          <p>1243 West Sycamore Lafayette GA, 29010</p>
        </div>
      </div>
      <div className="bottom-box-flex2">
        <a href="" className="contact-us-link">Contact Us</a>
        <div className="bottom-box-icon">
          <img src="/img/Group238491.png" />
          <img src="/img/Group238493.png" />
        </div>
      </div>
    </div>  
  </div>







</>
  );
}

export default CommunityActionCenterDetail;